import { Box, Button, Typography, useTheme } from '@mui/material'

import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getUserTypeFromToken, isAuthenticated } from '../../../_helpers/cookie'
import { useAppDispatch } from '../../../_helpers/hooks'
import { PlaceholderImageContainer } from '../../../components/common'
import { UnderConstructionIcon } from '../../../components/icons'
import { userDetails } from '../../../slices/userSlice'
const ComingSoonPage = () => {
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const loggedInUserType = getUserTypeFromToken()

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch(userDetails())
    }
  }, [dispatch])
  const handleClick = () => {
    if (loggedInUserType === 'business') {
      navigate('/admin/dashboard')
    } else if (loggedInUserType === 'customer') {
      navigate('/customer/business')
    } else {
      navigate('/')
    }
  }
  return (
    <Box minHeight={'100vh'}>
      <PlaceholderImageContainer
        color={'common.black'}
        text={t('comingSoon.comingSoonText1')}
        bordercolor={'transparent'}
        iconComponent={<UnderConstructionIcon fill={'none'} width='100%' height='auto' />}
      >
        <Box maxWidth={500}>
          <Typography textAlign={'center'} variant={'subtitle2'} color='secondary.main' mb={2}>
            <Trans
              i18nKey='comingSoon.comingSoonText2'
              components={{
                highlight: <span style={{ color: theme.palette.primary.main }} />,
              }}
            />
          </Typography>
        </Box>
        <Button
          variant='contained'
          onClick={handleClick}
          aria-label={t('comingSoon.backtoHomeComingSoonText')}
        >
          {t('comingSoon.backtoHomeComingSoonText')}
        </Button>
      </PlaceholderImageContainer>
    </Box>
  )
}

export default ComingSoonPage
